import React from 'react';
import { useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { useStyles } from '../styles';
import GroupTableRow from './GroupTableRow';


const GroupPatientResultTable = ({
  patientGroups,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  handleCloseModal
}) => {
  const classes = useStyles();
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const getPageData = () => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    return patientGroups.slice(startIndex, endIndex);
  };

  return (
    <div className="w-full">
      {!patientGroups?.length ? (
        <div className="flex justify-center">Marketing Segments not found</div>
      ) : (
        <TableContainer className={classes.tableContainer}>
          <div className="mx-8 mt-4">
            <Table
              className={classes.tableAutoLayout}
              aria-label="collapsible table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>
                    Marketing Segment Name
                  </TableCell>
                  <TableCell>
                    {`No. of ${isCustomer3 ? 'Customers' : 'Patients'}`}
                  </TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {getPageData().map((group, index) => (
                  <GroupTableRow
                    key={`patient-group-${index}`}
                    group={group}
                    handleCloseModal={handleCloseModal}
                  />
                ))}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            rowsPerPageOptions={[10, 20, 40, 80, 100]}
            component="div"
            className={classes.paginationContainer}
            count={patientGroups?.length}
            rowsPerPage={rowsPerPage}
            page={currentPage - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      )
      }
    </div>
  );
};

export default GroupPatientResultTable;
